import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class EntityHistoryEmployee  {
    _originalTypeClassName = "zERP.BO.EntityHistoryEmployee";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
EntityHistoryEmployee.translate = translateService;
}
this.lstEntityHistoryValue = [];
this.Id = null;
this.EffectiveFrom = null;
this.EffectiveTo = null;
this.Comments = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
EffectiveFrom:any;
EffectiveTo:any;
Comments:any;
lstEntityHistoryValue:any;
EntityType:any;
static setlstEntityHistoryValue = ($this, items) => {
                if (items == null) items = [];
                if ($this.lstEntityHistoryValue == null) $this.lstEntityHistoryValue = [];

                const copyItems = Common.cloneObject(items);

                while ($this.lstEntityHistoryValue.length > 0) {
                    Domain.EntityHistoryEmployee.removelstEntityHistoryValue($this, $this.lstEntityHistoryValue[0]);
                }

                Domain.EntityHistoryEmployee.addManylstEntityHistoryValue($this, copyItems);
            }
static addManylstEntityHistoryValue = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.EntityHistoryEmployee.addlstEntityHistoryValue($this, items[i]);
                }
            }
static addlstEntityHistoryValue = ($this, item) => {
                if ($this.lstEntityHistoryValue == null) $this.lstEntityHistoryValue = [];
                if (item == null || $this.lstEntityHistoryValue.indexOf(item) > -1) return;
                $this.lstEntityHistoryValue.push(item);
}
static addRangelstEntityHistoryValue = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.EntityHistoryEmployee.addlstEntityHistoryValue($this, item));
            }
static removelstEntityHistoryValue = ($this, item) => {
                if ($this == null || $this.lstEntityHistoryValue == null || $this.lstEntityHistoryValue.indexOf(item) === -1) return;
                var _index = $this.lstEntityHistoryValue.indexOf(item);
                $this.lstEntityHistoryValue.splice(_index, 1);
}
static clearlstEntityHistoryValue = ($this) => { $this.lstEntityHistoryValue = null; }
static setEntityType = ($this, value) => {
var oldValue = $this.EntityType;
$this.EntityType = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}